import styled from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const Header = styled(Flex.Row)`
    padding: ${theme.space[5]}px 0 ${theme.space[3]}px;
    text-align: start;
`;

export const Title = styled.h3`
    margin: 0;
    padding: 0;
    font-family: ${theme.fonts.base};
    font-size: 1.6rem;
    text-transform: none;
    color: ${theme.colors.primaryBlack};
`;
